<h2 *ngIf="data.showTitle" mat-dialog-title class="mat-dialog-custom-title">{{ data.title }}</h2>
<mat-dialog-content class="mat-dialog-custom-content" [innerHTML]="data.content">
    <!-- {{ data.content }} -->
</mat-dialog-content>
<mat-dialog-actions>
  <button class="vui-btn vui-secondary-btn" mat-dialog-close cdkFocusInitial>OK</button>
</mat-dialog-actions>